import { Set } from "immutable";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import { getSelectedCampaigns } from "../../../../data/voting-form/voting";

export class Finish extends React.Component {
  static propTypes = {
    selectedCampaigns: PropTypes.instanceOf(Set).isRequired,
    onCloseModal: PropTypes.func.isRequired,
  };

  handleCloseModal = () => {
    const { onCloseModal } = this.props;

    onCloseModal();
  };

  renderSelectedCampaigns() {
    const { selectedCampaigns } = this.props;

    const votedCampaigns = selectedCampaigns.reduce((campaigns, campaign) => {
      const votes = campaign.get("votes");
      const name = campaign.get("name");
      const id = campaign.get("id");

      if (votes > 0) {
        campaigns.push(
          <div key={id}>
            <span>
              <strong>{name}: </strong>
              {votes} {votes > 1 ? "votes" : "vote"}
            </span>
          </div>,
        );
      }
      return campaigns;
    }, []);

    return votedCampaigns;
  }

  render() {
    const { entity } = this.props;
    const donationConfirmationText = entity.get("donation_confirmation_text");

    return (
      <section className="voting-modal primary-color-background">
        <div className="voting-modal-background">
          <button
            data-testid="t-Finish-modal-close-button"
            aria-label="Modal Close Button"
            className="modal-close-button secondary-color-text"
            onClick={this.handleCloseModal}>
            <i className="fa fa-times fa-2x"></i>
          </button>
          <div className="voting-modal-top">
            <h2 className="voting-modal-header">
              Give &gt; Vote &gt;{" "}
              <span className="step-active secondary-color-text">Watch</span>
            </h2>
            <div className="white-font-color">Congrats! Your votes are in!</div>
          </div>
          <div className="voting-modal-body">
            <div className="voting-modal-body-inside">
              <div className="voting-modal-text-area">
                <h3>
                  <strong>You have placed your votes!</strong>
                </h3>
                <div className="m-sm-t m-sm-b">{this.renderSelectedCampaigns()}</div>
                {donationConfirmationText ? (
                  <span dangerouslySetInnerHTML={{ __html: donationConfirmationText }} />
                ) : (
                  <span>
                    Be sure to check in to see how the areas of interest rank on the
                    leaderboard.
                    <br />
                    <h4 className="voting-modal-subheader">Want more Votes?</h4>
                    <br />
                    &nbsp;Make another gift and receive more votes for your favorite areas
                    of interest!
                  </span>
                )}
              </div>
            </div>
          </div>
          <div>
            <button
              data-testid="t-Finish-button-2"
              className="voting-modal-btn secondary-color-background"
              onClick={this.handleCloseModal}>
              Finish
            </button>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedCampaigns: getSelectedCampaigns(state),
  };
};

export default connect(mapStateToProps)(Finish);
